import { RecordDataSource } from "../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetService,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import { machineConfigurationObjectName } from "../../shared/names";
import { machineConfigViewDefaultSort } from "./machineConfiguration";

export const vsObjectName = "machineConfigurationFile";

machineConfigurationFileConfig.$inject = [RecordGridViewServiceProviderName];
export function machineConfigurationFileConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  registerGrid(recordGridViewServiceProvider);
}

function registerGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ColumnDefinitionSetServiceName,
    ColumnDefinitionServiceName,
    ServerUtilityName,
    (
      columnDefinitionSetService: ColumnDefinitionSetService,
      columnDefinitionService: ColumnDefinitionService,
      serverUtility: ServerUtility
    ) => {
      return {
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/machines/MachineConfigurationFile"
        ),
        defaultSort: `${machineConfigViewDefaultSort},Id`,
        namePlural: "Machine Files",
        nameSingular: "Machine File",
        columns: [
          columnDefinitionService.getOptionColDef({
            field: "MachineConfigurationFileGroup",
            header: "File Group",
            options: [
              { display: "Compliance Files", value: "Compliance" },
              {
                display: "Software Compliance Notices",
                value: "SoftwareCompliance",
              },
              {
                display: "Internal Documentation",
                value: "InternalDocumentation",
              },
            ],
          }),
          columnDefinitionService.getChildFileColDef({
            prefix: "MachineConfigurationFile",
          }),
          ...columnDefinitionSetService.getColumnDefinitionSet(
            machineConfigurationObjectName
          ),
        ],
      };
    },
  ]);
}
